// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3gd13","rootCenter":"LoadMoreObserver_rootCenter__2PgEE","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__20Zt-"};